<template>
  <div class="attendances d-flex align-items-stretch h-100">
    <div id="page-content-wrapper" class="col p-0 d-flex">
      <div class="loader disable" v-show="loader"></div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  created() {
    if (!this.articleType || !this.articleId) {
      this.failedRoute();
    }
  },
  computed: {
    loader() {
      return this.$store.state.loader;
    },
    articleType() {
      return this.$route.params.articleType;
    },
    articleId() {
      return this.$route.params.articleId;
    }
  },
  methods: {
    failedRoute() {
      this.$router.push({
        path: "/admins/url-not-valid"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.attendances {
  background-color: #f9f9f9;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/layout/ArticleAttendanceLayout.vue